import styled from 'styled-components';
import { BLACK, DARK_VIOLET, NEUTRAL_300 } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding-right: 8px;
`;

export const IconNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const IconContainer = styled.div<{ $iconPlaceholder?: 'bank' | 'crypto' }>`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $iconPlaceholder }) => $iconPlaceholder ? '#f6ddfe' : 'transparent'};
  border-radius: 100%;
`;

export const IconImage = styled.img`
  width: 30px;
  height: 30px;
  aspect-ratio: 1/1;
  object-fit: fill;
  border-radius: 100%;
`;

export const NameText = styled.span`
  font-family: ${INTER.regular};
  color: ${DARK_VIOLET};
  font-size: 13px;
`;

export const BoldNameText = styled.span`
  color: ${BLACK};
  font-family: ${INTER.bold};
  font-size: 13px;
`;

export const GrayNameText = styled.span`
  color: ${NEUTRAL_300};
  font-family: ${INTER.regular};
  font-size: 13px;
`;
